import range from 'lodash/range';
import { isChordTuplet } from '../sheet';
import { sheetResolution, tickDuration } from './sheetToGrid';
function sheetTicks(sheet, resolution) {
    const ticks = [];
    const generateTick = ([absTick, resolution], notes, segment, segmentTick, repeat, measure, note, tupletNote) => {
        ticks.push({
            absTick,
            realValue: absTick / resolution,
            notes,
            segment,
            segmentTick,
            repeat,
            measure,
            note,
            tupletNote
        });
    };
    runSheet(sheet, generateTick, resolution);
    return ticks;
}
export function* generateSheetTicks(sheet, resolution) {
    yield* sheetTicks(sheet, resolution);
}
export function runSheet(sheet, visitor, tickNote) {
    const resolution = sheetResolution(sheet);
    if (tickNote != null && (resolution > tickNote || tickNote % resolution !== 0)) {
        throw new Error(`Cannot generate 1/${tickNote} grid from ${resolution} sheet`);
    }
    return sheet.segments.reduce(runSegment(tickNote ?? resolution, visitor), 0);
}
function runSegment(resolution, visitor) {
    return (initialOffset, segment, segmentIndex) => {
        if (resolution < segment.signature.denominator) {
            throw new Error(`Cannot generate 1/${resolution} grid from ${segment.signature.numerator}/${segment.signature.denominator} sheet`);
        }
        return range(0, (segment.repeats ?? 1) + 1).reduce((offset, repeatIndex) => segment.measures.reduce(runMeasure(resolution, visitor, segmentIndex, repeatIndex), [offset, 0])[0], initialOffset);
    };
}
function runMeasure(resolution, visitor, segment, repeat) {
    return ([initialOffset, initialSegmentOffset], measure, measureIndex) => {
        return measure.notes.reduce(reduceNote, [initialOffset, initialSegmentOffset]);
        function reduceNote([offset, segmentOffset], note, noteIndex) {
            return isChordTuplet(note)
                ? reduceTuplet(offset, segmentOffset, note, noteIndex)
                : reduceChord(offset, segmentOffset, note, noteIndex);
        }
        function reduceTuplet(initialOffset, initialSegmentOffset, tuplet, noteIndex) {
            const [numerator, denominator] = tickDuration(tuplet);
            const duration = (numerator * resolution / denominator);
            tuplet.chords.forEach((notes, tupletIndex) => {
                const segmentTick = initialSegmentOffset + (tupletIndex * duration);
                const absTick = initialOffset + (tupletIndex * duration);
                visitor([absTick, resolution], notes, segment, segmentTick, repeat, measureIndex, noteIndex, tupletIndex);
            });
            return [initialOffset + duration * tuplet.chords.length, initialSegmentOffset + duration * tuplet.chords.length];
        }
        function reduceChord(initialOffset, initialSegmentOffset, chord, noteIndex) {
            const [numerator, denominator] = tickDuration(chord);
            const duration = (numerator * resolution / denominator);
            if (duration < 1) {
                throw new Error('Higher resolution needed');
            }
            visitor([initialOffset, resolution], chord.notes, segment, initialSegmentOffset, repeat, measureIndex, noteIndex, 0);
            range(1, duration).forEach(index => {
                const segmentTick = initialSegmentOffset + index;
                const absTick = initialOffset + index;
                visitor([absTick, resolution], [], segment, segmentTick, repeat, measureIndex, noteIndex + index, 0);
            });
            return [initialOffset + duration, initialSegmentOffset + duration];
        }
    };
}
//# sourceMappingURL=generateSheetTicks.js.map